var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank","rel":"noopener noreferrer","href":_vm.listViewUrl}},[_c('span',{staticClass:"list-view-link-text"},[_vm._v(_vm._s(this.$t('label.listviewlink')))])])}
var staticRenderFns = []

export { render, staticRenderFns }